'use strict';

export default class GlobalUtil {


    constructor(_paramQuery, config) {
        this.paramQuery = _paramQuery;
        this.config = config;

    }
    getIsArray(array) {
        return Array.isArray(array);
    }
    getFirstPathSegment() {
        return window.location.pathname.split('/')[1];
    }
    convertPaxesData(paxes) {
        const convertedData = paxes.reduce((accumulator, currentValue) => {
            accumulator.adults += currentValue.adults || 0;
            accumulator.children = accumulator.children.concat(currentValue.children || []);
            return accumulator;
        }, { adults: 0, children: [] });
        
        convertedData.rooms = paxes.length;
        return convertedData;
    }

    getUserKey(localStorageService) {
        const fn = window.__pt.fn;
        const ca_chat = `anonimo-${fn.generateUUID()}`;
        const cookieUserKey = fn.getCookie("__ca__chat") || ca_chat;
        const storedUserKey = localStorageService.get('userKey');

        if (storedUserKey && !storedUserKey.includes('anonimo')) {
            return storedUserKey;
        }

        if (cookieUserKey) {
            localStorageService.set('userKey', cookieUserKey);
            return cookieUserKey;
        }

        setTimeout(() => {
            const fallbackUserKey = fn.getCookie("__ca__chat") || ca_chat;
            localStorageService.set('userKey', fallbackUserKey);
        }, 2000);

        return '';
    }

    getUserKeyFavorites(localStorageService) {
        let fn = window.__pt.fn;
        let _user = window.__pt.user || null;
        let ca_chat = `anonimo-${fn.generateUUID()}`;

        // Check user.firebaseId first
        let uKey = _user && _user.firebaseId ? _user.firebaseId : (fn.getCookie("session_id") || ca_chat);
        let storedUserKey = localStorageService.get('userKey_fav');

        // If a userKey is stored and matches the current user's firebaseId, return it
        if (storedUserKey && storedUserKey === uKey) {
            return storedUserKey;
        }

        // If userKey is not stored or doesn't match the current user's firebaseId, update it
        if (uKey) {
            localStorageService.set('userKey_fav', uKey);
            return uKey;
        }

        setTimeout(() => {
            let uKey = _user && _user.firebaseId ? _user.firebaseId : (fn.getCookie("session_id") || ca_chat);
            localStorageService.set('userKey_fav', uKey);
        }, 2000);

        return '';
    }
    
    
    
  
    getPaxes(box) {
        let boxLength = box.pax && box.pax.length;
        let paxes = {
            adults: 0,
            children: 0,
            paxesFormat: []
        };

        for (let i = 0; box.pax && i < boxLength; i++) {
            const pax = box.pax[i];
            let paxFormat = "";
            paxes.adults += pax.adults;
            paxFormat += `${pax.adults}/`;

            if (pax.children && pax.children.length) {
                paxes.children += pax.children.length;
                paxFormat += `${pax.children.map(it => it.year).join(',')}`;
            } else {
                paxFormat += 'n';
            }

            paxes.paxesFormat.push(paxFormat);
        }

        return paxes;
    }
    getPaxesFavorites(box) {
        let boxLength = box && box.length;
        let paxes = {
            adults: 0,
            children: 0,
            paxesFormat: []
        };

        for (let i = 0; box && i < boxLength; i++) {
            const pax = box[i];
            let paxFormat = "";
            paxes.adults += pax.adults;
            paxFormat += `${pax.adults}/`;

            if (pax.children && pax.children.length) {
                paxes.children += pax.children.length;
                paxFormat += `${pax.children.map(it => it.year).join(',')}`;
            } else {
                paxFormat += 'n';
            }

            paxes.paxesFormat.push(paxFormat);
        }

        return paxes;
    }
    getPaxesRates(box) {
        let boxLength = box.pax && box.pax.length;
        let paxes = {
            adults: 0,
            children: 0,
            paxesFormat: []
        };
        for (let i = 0; box.pax && i < boxLength; i++) {
            const pax = box.pax[i];
            let paxFormat = "";
            paxes.adults += pax.adults;
            paxFormat += `${pax.adults}`;

            if (pax.children && pax.children.length) {
                paxes.children += pax.children.length;
                paxFormat += `|${pax.children.map(it => it.year).join(',')}`;
            }

            paxes.paxesFormat.push(paxFormat);
        }
        return paxes;
    }

    getPaxToMessages(newPax) { 
        return newPax.paxesFormat.map(rm => {
            const parts = rm.split('|');
            const adults = parts[0];
            const children = parts.length > 1 ? parts[1].split(',').join('_') : '';
            return `${adults}${children ? '_' : ''}${children}`;
        });
    }


    getAgeKids(box) {
        return (box.pax[0].children.map(item=>item.year)).join(',');
    }

    getShowPromotion(taxes) {
        var activeKey = false;
        var isBlackAndFriday = false;
        var promotionsToShow = this.config.promotionKeyShow;
        if (promotionsToShow) {
            var promotionToFind = taxes ? promotionsToShow.find(x => x.key == taxes.promotionType) : "";
            if (promotionToFind) {
                activeKey = promotionToFind.active;
                isBlackAndFriday = promotionToFind.blackFAndHotS;
            }
        }
        var responsePromotion = {
            activeKey: activeKey,
            HotSBlackFri: isBlackAndFriday
        }
        return responsePromotion;
    }

    windowScrollTop(){
        window.scrollTo(0, 0);
    }
}
